// cspell:ignore grpcs ipens

import { PageBlueprint } from '@backstage/frontend-plugin-api';
import { Navigate } from 'react-router';

const redirects = {
  '/': '/home',
  '/apis': '/catalog/default/domain/ipen-domain/apis',
  '/catalog/:namespace/domain/:name/catalog': '/marketplace',
  '/catalog/:namespace/domain/energy-network-domain': '/marketplace',
  '/catalog/:namespace/domain/energy-network-domain/*': '/marketplace',
  '/chapters': '/catalog/default/group/ipen-platform-tribe/chapters',
  '/coreprocesses': '/catalog',
  '/grpcs': '/catalog',
  '/ipens': '/catalog',
  '/news': '/catalog/default/group/ipen-platform-tribe/news',
  '/openapis': '/catalog',
  '/partner-systems': '/catalog/default/domain/ipen-domain/partner-systems',
  '/products': '/catalog/default/domain/ipen-domain/products',
  '/services': '/catalog',
  '/solutions': '/marketplace',
  '/squads': '/catalog/default/group/ipen-platform-tribe/squads',
  '/websites': '/catalog',
} as const;

export const RedirectRoutes = Object.entries(redirects).map(
  ([source, target]) =>
    PageBlueprint.make({
      name: 'redirect-' + source.replaceAll('/', '|'),
      params: {
        loader: async () => <Navigate replace to={target} />,
        noHeader: true,
        path: source,
      },
    }),
);
